/**
 * 获取数据
  GET /assistant/temp/get
  接口ID：141756275
  接口地址：https://app.apifox.com/link/project/3794105/apis/api-141756275
 */

import { post } from "../../../../../utils";
export var apiLegacyTaskHandle = function apiLegacyTaskHandle(taskCode, taskData, action) {
  return post({
    url: '/cbs/project/task/handle',
    data: {
      taskCode: taskCode,
      formValue: JSON.stringify(taskData),
      action: action
    },
    loading: true,
    errorTip: true
  });
};